function checkUserLocationByLanguages(code) {
  const languageList = [];
  let result = false;
  if (typeof window !== "undefined") {
    if (window.navigator.languages) {
      languageList.push(...window.navigator.languages);
    }
    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }
    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }
    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }
    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }
  for (let i = 0; i < languageList.length; i++) {
    if (languageList[i].toLowerCase().indexOf(code) > -1) {
      result = true;
      break;
    }
  }
  return result;
}

const currency = checkUserLocationByLanguages("hk") ? "hkd" : "usd";

const locale = (state = { fetched: false, currency }, action) => {
  switch (action.type) {
    case "SET_LOCALE":
      return { ...action.locale, fetched: true };
    default:
      return state;
  }
};

export default locale;



// WEBPACK FOOTER //
// ./src/reducers/locale.js